/**
 * MYNAVI（マイナビ進学）ブランドトークン
 *
 * Mantine に依存しない純粋定数なので、どの層（Layout / Campaign 等）からも import 可能。
 * MYNAVI 専用の色・フォントの単一ソースとして利用する。
 *
 * @example
 * import { mynaviTheme } from '@/theme/mynavi'
 * style={{ color: mynaviTheme.primary, fontFamily: mynaviTheme.fontFamily }}
 */
export const mynaviTheme = {
  /** プライマリカラー（見出し等） */
  primary: '#058bbe',
  /** 本文テキストカラー */
  bodyText: '#686868',
  /** 共通フォントファミリー */
  fontFamily: "'BIZ UDPGothic', sans-serif",
} as const
